/**
 * Katalog chyb API (kap. 69): server vrací `code` + českou zprávu; v angličtině web ukáže
 * překlad podle kódu, neznámý kód nechá původní text. Klíče = `error.code` z API.
 */
export const ERROR_MESSAGES: Record<'cs' | 'en', Record<string, string>> = {
  cs: {},
  en: {
    UNAUTHORIZED: 'Please sign in.',
    FORBIDDEN: 'You do not have permission for this action.',
    MFA_REQUIRED:
      'This company requires two-factor authentication for your role – enable it in Account.',
    RATE_LIMITED: 'Too many requests, try again in a moment.',
    ACCOUNT_LOCKED: 'The account is temporarily locked after repeated failed sign-ins.',
    NOT_FOUND: 'Not found.',
    VALIDATION: 'Check the highlighted fields.',
    INSUFFICIENT_STOCK: 'Not enough stock for this item.',
    PERIOD_CLOSED: 'The accounting period is closed.',
    DUPLICATE: 'This record already exists.',
    APPROVAL_REQUIRED: 'The document is above the limit and awaits approval.',
    DOCUMENT_DRAFT: 'Issue the draft first.',
    DOCUMENT_CANCELLED: 'The document is cancelled.',
    FEATURE_DISABLED: 'This feature is not enabled for the company.',
    NETWORK: 'Could not reach the server.',
    INTERNAL: 'Something went wrong. Please report the error ID.',
    TELEGRAM_DISABLED: 'Telegram is not configured on the server.',
    NO_EMAIL: 'The customer has no e-mail – add one or enter an address.',
    IDEMPOTENCY_MISMATCH: 'The same key was used with a different request.',
  },
};

export function localizedError(code: string, message: string, locale: string): string {
  const table = ERROR_MESSAGES[locale === 'en' ? 'en' : 'cs'];
  return table[code] ?? message;
}
